import React, { useContext } from "react";
import plusImg from "../assets/plus.svg";
import GlobalContext from "../context/GlobalContext";
export default function CreateEventButton() {
  const { setShowEventModal, userDetails } = useContext(GlobalContext);
  return (
    <>
      {userDetails != null &&  userDetails.success ? (
        <button
          onClick={() => setShowEventModal(true)}
          className="border p-2 rounded-full flex items-center shadow-md hover:shadow-2xl"
        >
          <img src={plusImg} alt="create_event" className="w-10 h-10" />
          <span className="pl-3 pr-7"> Create</span>
        </button>
      ) : (
        <button
          onClick={() => alert("Please Login To Create a Slot")}
          className="border p-2 rounded-full flex items-center shadow-md hover:shadow-2xl"
        >
          <img src={plusImg} alt="create_event" className="w-10 h-10" />
          <span className="pl-3 pr-7"> Create</span>
        </button>
      )}
    </>
  );
}
